import AnimatedLogo from "@/app/_media/animatedLogo.svg";
import { LoadingOverlay, Flex, Image, Text } from "@mantine/core";
import NextImage from "next/image";
import React from "react";

interface AnimatedLoaderProps {
  text?: string;
  bkgOpacity?: number;
}

const AnimatedLoader = React.memo(
  ({ bkgOpacity = 0.8, text }: AnimatedLoaderProps) => {
    return (
      <LoadingOverlay
        visible={true}
        zIndex={1000}
        loaderProps={{
          children: (
            <Flex direction="column" align="center" justify="center">
              <Image
                component={NextImage}
                w={128}
                h={128}
                src={AnimatedLogo}
                alt="Loading..."
                priority
              />
              {text && (
                <Text size="xl" mt="sm" inline>
                  {text}
                </Text>
              )}
            </Flex>
          ),
        }}
        overlayProps={{ backgroundOpacity: bkgOpacity }}
      />
    );
  }
);

AnimatedLoader.displayName = "AnimatedLoader";

export default AnimatedLoader;
